export const translations = {
  ro: {
    nav: {
      about: "Despre",
      services: "Servicii",
      blog: "Jurnal",
      contact: "Contact",
      bookCta: "Programează",
    },
    hero: {
      overline: "Cabinet Individual de Avocat — Baroul Galați",
      titleLine1: "Martiș",
      titleLine2: "Biatrice-Olimpia",
      tagline:
        "Servicii juridice de înaltă rezoluție. Discreție absolută, strategie procesuală și prezență fermă în fața instanțelor.",
      ctaPrimary: "Solicită consultație",
      ctaSecondary: "Despre cabinet",
      stat1Label: "Intrare în Barou",
      stat1Value: "2000",
      stat2Label: "Ani de experiență",
      stat2Value: "26",
      stat3Label: "Dosare reprezentate",
      stat3Value: "3000+",
    },
    about: {
      overline: "Despre cabinet",
      title: "O abordare clasică,\no rigoare contemporană.",
      paragraph1:
        "Activitatea Cabinetului Individual de Avocat „Martiș Biatrice-Olimpia” este organizată în conformitate strictă cu prevederile Legii nr. 51/1995 pentru organizarea și exercitarea profesiei de avocat și ale Statutului profesiei de avocat.",
      paragraph2:
        "Asigurăm independența deplină, păstrarea secretului profesional și devotamentul necondiționat față de interesele legitime ale clientului. Fiecare cauză primește atenția unei strategii personalizate, construite cu rigoarea unui dosar judecat la cea mai înaltă instanță.",
      bullets: [
        "Membru al Baroului Galați din anul 2000",
        "Peste 26 de ani de experiență juridică",
        "Strategie procesuală personalizată",
        "Confidențialitate absolută",
        "Disponibilitate pentru cauze de complexitate ridicată",
      ],
    },
    services: {
      overline: "Practica juridică",
      title: "Servicii conforme\nLegii avocaturii.",
      items: [
        {
          title: "Consultații juridice",
          desc: "Redactarea de opinii legale scrise, cu analiza speței și recomandări strategice.",
        },
        {
          title: "Asistență & reprezentare",
          desc: "Apărarea drepturilor în fața instanțelor judecătorești, naționale și locale.",
        },
        {
          title: "Redactare acte juridice",
          desc: "Contracte, statute, acte constitutive cu atestarea identității părților.",
        },
        {
          title: "Apărare cauze penale",
          desc: "Asistență juridică în fața organelor de urmărire penală și a instanțelor.",
        },
        {
          title: "Dreptul familiei",
          desc: "Divorț, partaj, custodie, pensie de întreținere — cu discreție și demnitate.",
        },
        {
          title: "Drept comercial",
          desc: "Constituiri societăți, contracte, litigii între profesioniști, recuperări creanțe.",
        },
      ],
    },
    fees: { _removed: true },
    calculator: { _removed: true },
    blog: {
      overline: "Jurnal juridic",
      title: "Articole & opinii.",
      readMore: "Citește mai mult",
      minutes: "min",
      back: "Înapoi la jurnal",
    },
    contact: {
      overline: "Contact",
      title: "Programează o consultație.",
      intro:
        "Completează formularul de mai jos. Vă vom răspunde în maximum 24 de ore lucrătoare, cu confidențialitate deplină.",
      name: "Nume complet",
      email: "Email",
      phone: "Telefon",
      service: "Serviciu solicitat",
      message: "Descriere succintă a cauzei",
      submit: "Trimite cererea",
      sending: "Se trimite...",
      success: "Cerere transmisă. Veți fi contactat în cel mai scurt timp.",
      error: "A apărut o eroare. Vă rugăm încercați din nou.",
      phoneLabel: "Telefon",
      emailLabel: "Email",
      addressLabel: "Sediu",
      address: "Strada Brăilei nr. 153, Galați",
      bar: "Membru al Baroului Galați",
    },
    footer: {
      rights: "Toate drepturile rezervate, conform Legii 51/1995.",
      legal: "Cadru legal: Legea 51/1995 · Statutul profesiei de avocat",
    },
    cookies: {
      title: "Confidențialitate & cookie-uri",
      body:
        "Acest site folosește cookie-uri strict necesare pentru funcționare și, opțional, cookie-uri analitice pentru a înțelege modul de utilizare. Conform Regulamentului (UE) 2016/679 (GDPR) și Legii nr. 506/2004, aveți dreptul de a accepta, refuza sau personaliza utilizarea acestora. Datele transmise prin formularul de contact sunt prelucrate exclusiv în scopul soluționării cererii dvs.",
      accept: "Accept toate",
      reject: "Refuz opționale",
      details: "Detalii",
      close: "Închide",
      policyTitle: "Politica de confidențialitate",
      policy: [
        "Operator de date: Cabinet Individual de Avocat Martiș Biatrice-Olimpia, Baroul Galați, str. Brăilei nr. 153, Galați.",
        "Date prelucrate: nume, email, telefon, mesaj — colectate exclusiv prin formularul de contact.",
        "Scop: răspuns la solicitare și eventuala formalizare a unui contract de asistență juridică.",
        "Temei legal: art. 6 alin. (1) lit. b) GDPR (măsuri precontractuale) și obligația legală conform Legii 51/1995.",
        "Durată: maximum 36 de luni de la ultima interacțiune, în lipsa unui mandat activ.",
        "Drepturile dvs.: acces, rectificare, ștergere, restricționare, opoziție, portabilitate, plângere la ANSPDCP.",
        "Contact responsabil: martisbiatrix@gmail.com · 0720 201 887.",
      ],
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Practice",
      blog: "Journal",
      contact: "Contact",
      bookCta: "Book",
    },
    hero: {
      overline: "Individual Attorney's Office — Galați Bar",
      titleLine1: "Martiș",
      titleLine2: "Biatrice-Olimpia",
      tagline:
        "High-resolution legal services. Absolute discretion, procedural strategy, and a firm presence before the courts.",
      ctaPrimary: "Request consultation",
      ctaSecondary: "About the office",
      stat1Label: "Bar admission",
      stat1Value: "2000",
      stat2Label: "Years of experience",
      stat2Value: "26",
      stat3Label: "Cases represented",
      stat3Value: "3000+",
    },
    about: {
      overline: "About the office",
      title: "A classical approach,\na contemporary rigor.",
      paragraph1:
        "The Individual Attorney's Office “Martiș Biatrice-Olimpia” operates in strict compliance with Law No. 51/1995 governing the organization and practice of the legal profession, and with the Statute of the Profession of Attorney.",
      paragraph2:
        "We guarantee full independence, professional secrecy and unconditional devotion to the client's legitimate interests. Every case receives the attention of a personalised strategy, built with the rigour of a brief argued before the highest court.",
      bullets: [
        "Member of the Galați Bar since 2000",
        "Over 26 years of legal experience",
        "Tailored procedural strategy",
        "Absolute confidentiality",
        "Availability for complex matters",
      ],
    },
    services: {
      overline: "Areas of practice",
      title: "Services under the\nLegal Profession Act.",
      items: [
        {
          title: "Legal consultations",
          desc: "Written legal opinions, including case analysis and strategic recommendations.",
        },
        {
          title: "Assistance & representation",
          desc: "Defending rights before national and local judicial bodies.",
        },
        {
          title: "Drafting legal acts",
          desc: "Contracts, statutes, articles of association — with party identity attestation.",
        },
        {
          title: "Criminal defence",
          desc: "Legal assistance before prosecution bodies and courts at every stage.",
        },
        {
          title: "Family law",
          desc: "Divorce, asset division, custody, alimony — handled with discretion and dignity.",
        },
        {
          title: "Commercial law",
          desc: "Company incorporation, contracts, professional disputes, debt recovery.",
        },
      ],
    },
    fees: { _removed: true },
    calculator: { _removed: true },
    blog: {
      overline: "Legal journal",
      title: "Articles & opinions.",
      readMore: "Read more",
      minutes: "min",
      back: "Back to journal",
    },
    contact: {
      overline: "Contact",
      title: "Book a consultation.",
      intro:
        "Complete the form below. We will respond within at most 24 working hours, in full confidentiality.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      service: "Requested service",
      message: "Brief description of the case",
      submit: "Send request",
      sending: "Sending...",
      success: "Request sent. You will be contacted shortly.",
      error: "An error occurred. Please try again.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Office",
      address: "Strada Brăilei No. 153, Galați",
      bar: "Member of the Galați Bar",
    },
    footer: {
      rights: "All rights reserved under Law 51/1995.",
      legal: "Legal framework: Law 51/1995 · Statute of the Profession",
    },
    cookies: {
      title: "Privacy & cookies",
      body:
        "This website uses strictly necessary cookies for operation and, optionally, analytics cookies to understand usage. Under Regulation (EU) 2016/679 (GDPR) and Romanian Law 506/2004, you may accept, decline, or customise their use. Data submitted through the contact form is processed solely to answer your enquiry.",
      accept: "Accept all",
      reject: "Decline optional",
      details: "Details",
      close: "Close",
      policyTitle: "Privacy policy",
      policy: [
        "Data controller: Individual Attorney's Office Martiș Biatrice-Olimpia, Galați Bar, Strada Brăilei No. 153, Galați, Romania.",
        "Processed data: name, email, phone, message — collected only through the contact form.",
        "Purpose: answering the enquiry and possibly entering into a legal-assistance contract.",
        "Legal basis: Art. 6 (1) (b) GDPR (pre-contractual measures) and legal obligation under Law 51/1995.",
        "Retention: max. 36 months from the last interaction, in the absence of an active mandate.",
        "Your rights: access, rectification, erasure, restriction, objection, portability, complaint to ANSPDCP.",
        "Officer in charge: martisbiatrix@gmail.com · +40 720 201 887.",
      ],
    },
  },
};

export const useT = (lang) => translations[lang] || translations.ro;
